import { useTranslation } from 'react-i18next';
import { Typography, Button, Icon, useTheme } from '../../../base';
import {
    StyledDialog,
    StyledCloseButton,
    StyledContent,
    StyledActions,
} from './DeleteTemplateModal.styles';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
}

const DeleteTemplateModal = ({
    open,
    onClose,
    onConfirm,
    isLoading = false,
}: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <StyledDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <StyledCloseButton onClick={onClose} size="small">
                <Icon name="CloseIcon" size={22} />
            </StyledCloseButton>
            <StyledContent>
                <Icon
                    name="DeleteIcon"
                    size={44}
                    color={theme.palette.primary.main}
                />
                <Typography
                    variant="h5"
                    fontWeight={700}
                    color={theme.palette.primary.main}
                >
                    {t('settings.emailTemplates.deleteModal.title')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {t('settings.emailTemplates.deleteModal.message')}
                </Typography>
                <Typography variant="body2" color={theme.palette.primary.main}>
                    {t('settings.emailTemplates.deleteModal.warning')}
                </Typography>
            </StyledContent>
            <StyledActions direction="row" spacing={1.5}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onClose}
                    sx={{ paddingInline: 6 }}
                >
                    {t('settings.emailTemplates.cancel')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onConfirm}
                    disabled={isLoading}
                    sx={{ paddingInline: 6 }}
                >
                    {t('settings.emailTemplates.delete')}
                </Button>
            </StyledActions>
        </StyledDialog>
    );
};

export default DeleteTemplateModal;
